// Helpers for sharing the current leaderboard page link.

export const nativeShareAvailable = () =>
  typeof navigator !== 'undefined' && typeof navigator.share === 'function'

// Copy through a temporary input + execCommand. Still the only way to copy
// where the async Clipboard API is missing (insecure contexts, old browsers)
// or rejects (cross-origin embeds: the permissions policy blocks the API,
// while execCommand still honors the click's user activation).
const execCommandCopy = (text) =>
  new Promise((resolve, reject) => {
    const input = document.createElement('input')
    input.value = text
    // Invisible and inert: no layout shift, no focus scroll, no iOS keyboard.
    input.setAttribute('readonly', '')
    input.style.position = 'fixed'
    input.style.opacity = '0'
    document.body.appendChild(input)
    try {
      input.select()
      // execCommand signals failure by returning false more often than by
      // throwing - resolving on false would confirm a copy that never happened.
      if (document.execCommand('copy')) {
        resolve()
      } else {
        reject(new Error('execCommand copy rejected'))
      }
    } catch (error) {
      reject(error)
    } finally {
      input.remove()
    }
  })

// Copies text to the clipboard. Prefers the async Clipboard API, falling back
// to execCommandCopy both where the API is absent and where it exists but
// rejects. Always returns a Promise.
export const copyToClipboard = (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text).catch(() => execCommandCopy(text))
  }

  return execCommandCopy(text)
}
